const checkTaskPattern = (task: string) => {
  const hashPattern = /#([a-zA-Z0-9-]+)/i;
  const linkPattern =
    /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)/i;

  return hashPattern.test(task) || linkPattern.test(task) || task.length >= 32;
};
export default checkTaskPattern;
